import { LayUpStatuses, LayUpStatusFilter } from '@src/constants/LayupStatuses';
import useApi, { ApiOptions } from '../base/useApi';

interface ForeignKeyDTO {
  id: string;
  name: string;
}

interface LayUpsOperatingListDTO {
  layUps: LayUpsOperatingListsDTO[];
  categoriesLists: ForeignKeyDTO[];
}

interface LayUpsOperatingListsDTO {
  id: string;
  procedureName: string;
  status: LayUpStatuses;
  items: LayUpItemsDTO[];
}

export type LayUpItemsDTO = {
  cardItemId: string;
  name: string;
  categoryId: string;
  isOnHand: string;

  quantity: number;
  quantityPicked: number;
  quantityChecked: number;

  isMissingPicked: boolean;
  isMissingChecked: boolean;
  isMissingCheckedConfirmed: boolean;
};

interface Params {
  hospitalId: string;
  fromDate: Date;
  operatingListId: string;
  consultantId: string;
  status?: LayUpStatusFilter;
}

type Result = LayUpsOperatingListDTO;

const options: ApiOptions = {
  method: 'get',
  urlPath: '/layups/operating_list',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetLayUpOperatingList = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetLayUpOperatingList;
